(function (_) {
    'use strict';

    _['LOYALTY.KEY'] = 'Fidelização';
    _['LOYALTY.EMPTY-LIST'] = 'Não há cartões de fidelização ativos neste momento';
    _['LOYALTY.VALID-FROM'] = 'Desde: ';
    _['LOYALTY.VALID-UNTIL'] = 'Até: ';
    _['LOYALTY.NO-LIMIT'] = 'Sem limites';
    _['LOYALTY.CONDITIONS'] = 'Condições';
    _['LOYALTY.CANCEL'] = 'Cancelar';
    _['LOYALTY.ACCEPT'] = 'Aceitar';
    _['LOYALTY.EXCEPTIONS-TITLE'] = 'Exceções';
    _['LOYALTY.PERIOD-VALIDITY'] = 'Período de validade';
    _['LOYALTY.HOW-STAMP-TITLE'] = 'Como carimbar:';
    _['LOYALTY.HOW-STAMP-CONTENT'] = 'Por favor, mostre seu código QR ou insere o código na caixa de validação.';
    _['LOYALTY.HOW-STAMP-CONTENT-ONLY-CODE'] = 'Por favor, insere seu código na caixa de validação.';
    _['LOYALTY.DAILY-LIMIT'] = 'Excedeste o limite diário';
    _['LOYALTY.VALID-CODE'] = 'Código válido';
    _['LOYALTY.INVALID-CODE'] = 'Código inválido';
    _['LOYALTY.GIFT-FREEBIENAME'] =  'Parabéns! Tens um grátis:';
    _['LOYALTY.CODE-PLACEHOLDER'] = 'Digite o código';

}(translations['pt']));



// WEBPACK FOOTER //
// ./src/app/modules/loyalty/lang/loyalty-lang_pt.js